import TabMenu from '@/components/tab_menu/TabMenu.vue';
import SideBar from '@/components/side_bar/SideBar.vue';
import ConciergeAccount from '@/components/concierge_account/ConciergeAccount.vue';
import ConciergeProfile from '@/components/concierge_profile/ConciergeProfile.vue';

import apiConcierge from '@/api/concierge';

export default {
  created() {
    this.getConciergeProfile();
  },
  data: function() {
    return {
      conciergeId: this.$router.history.current.params.conciergeId,
      conciergeInfo: {},
      conciergeAccount: {},
      conciergeProfile: {},
      tabMenu: {
        items: {
          accounts: {
            label: 'Accounts'
          },
          profile: {
            label: 'My Profile'
          }
        },
        currentTab: 'accounts'
      }
    };
  },
  components: {
    TabMenu,
    SideBar,
    ConciergeAccount,
    ConciergeProfile
  },
  methods: {
    getConciergeProfile: async function() {
      this.conciergeInfo = await apiConcierge.getConcierge(this.conciergeId);
      if (this.conciergeInfo.conciergeLevel === '99') {
        this.conciergeInfo.isPartnerConcierge = 1;
      } else {
        this.conciergeInfo.isPartnerConcierge = 0;
      }

      const { email, firstName, lastName } = this.conciergeInfo;
      this.conciergeAccount = {
        email,
        firstName,
        lastName
      };
    }
  }
};
